import { BuildOutlined } from '@ant-design/icons';
import { memo } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Empty from '@/components/Empty/Empty';
import List from '@/components/List/List';
import TaxonomyListItem from '@/features/Taxonomy/components/TaxonomyListItem/TaxonomyListItem';
import { cn } from '@/lib/cn';

import useTaxonomyListAction from './useTaxonomyListAction';

type Props = {
  taxonomyList?: TaxonomyT[];
  isFetching: boolean;
  onCreateClick: () => void;
  onEditClick: (alias: string) => void;
};

const TaxonomyList = (props: Props) => {
  const { onDeleteClick, onStarClick, onItemClick } = useTaxonomyListAction();

  return (
    <Style>
      <List
        className={cn(
          'grid place-items-stretch w-full pt-3 px-8 pb-8 gap-5 h-fit',
          props.taxonomyList && props.taxonomyList.length > 0
            ? 'grid-cols-[repeat(auto-fill,minmax(320px,1fr))]'
            : 'grid-cols-[repeat(1,1fr)]',
        )}
        isLoading={props.isFetching}
        data={props.taxonomyList}
        placeholder={{
          node: (
            <Empty
              icon={<BuildOutlined />}
              action={{
                onClick: props.onCreateClick,
                text: 'Create',
              }}
              title="Create your taxonomy"
              description={`Create taxonomy(s) to auto-classify all your customer feedback.
                Leverage various filters for more in-depth analysis.`}
            />
          ),
        }}
        render={(t) => (
          <TaxonomyListItem
            key={t.alias}
            {...t}
            callbacks={{
              onClick: onItemClick,
              onEditClick: props.onEditClick,
              onDeleteClick,
              onStarClick,
            }}
          />
        )}
      />
    </Style>
  );
};

const Style = styled(Flex)`
  flex: 1;
`;

export default memo(TaxonomyList);
